import { ChangeDetectionStrategy, Component, input, output, computed, ElementRef, Renderer2, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { NUserNotifications } from '../../user-notifications.service';
import { injectTimeoutService } from '@df/ng/timeout.service';

@Component({
    selector: 'app-user-notification-modal-item',
    templateUrl: './user-notification-modal-item.component.html',
    styleUrls: ['./user-notification-modal-item.component.scss'],
    standalone: true,
    imports: [CommonModule, DfImageDirective, HrefComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserNotificationModalItemComponent {
    notification = input.required<NUserNotifications.INotification>();
    closeNotification = output<string>();

    // Computed signals for notification properties
    protected image = computed(() => this.notification().image);
    protected title = computed(() => this.notification().title);
    protected subtitle = computed(() => this.notification().subtitle);
    protected link = computed(() => this.notification().link);

    private renderer2 = inject(Renderer2);
    private elementRef = inject(ElementRef);
    private timeoutService = injectTimeoutService();

    protected handleClose(): void {
        this.renderer2.addClass(this.elementRef.nativeElement, '_closed');
        this.timeoutService.setTimeout(() => this.close(), 300);
    }

    protected handleLinkClick(): void {
        // Close the notification when link is clicked
        this.handleClose();
    }

    private close(): void {
        this.closeNotification.emit(this.notification().id);
    }
}
